<template lang="pug">
  .data-row(:class="{ 'data-row-is-link': isLink }", @click="$emit('click')")
    .data-row-label(v-if="!valueOnly")
      slot(name="label") {{ label }}
      span.data-row-required(v-if="required") *
    .data-row-value(:class="{ 'value-only': valueOnly,'text-algin-left':alginLeft ,'data-form': isForm ,'disabled':disabled}")
      slot
    .data-row-append(v-if="$slots.append")
      slot(name="append")
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    alginLeft: {
      type: Boolean,
      default: false
    },
    next: {
      type: Boolean,
      default: false
    },
    valueOnly: {
      type: Boolean,
      default: false
    },
    isLink: {
      type: Boolean,
      default: false
    },
    isForm: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less">
@import (reference) "../assets/general";
.data-row-group {
  .border-box;
  .max-width;
  padding: 0 0.3rem;
  margin-bottom: 0.2rem;
  background: @white;

  .data-row {
    padding: 0;
  }
  .data-row-is-link {
    padding-right: 1em;
  }
}

.data-row {
  .flex(center, space-between);
  min-height: 48px;
  padding: 0 15px;
  font-size: 14px;
  background: @white;
  border-top: 1px solid @hr-grey;

  &:last-child {
    border-bottom: 1px solid @hr-grey;
  }
}

.data-row-required {
  color: @background-red-2;
}

.data-row-label {
  min-width: 25%;
}

.data-row-append {
  margin-left: 10px;
}

.data-row-value {
  flex: 1;
  word-break: break-all;
  .align-right;

  input {
    .max-width;
    .align-right;
    font-size: 0.28rem;

    border: none;
    outline: none;
  }

  select {
    .max-width;
    .align-right;
    background: transparent;
    border: none;
    outline: none;
  }
}
.value-only {
  .max-width;
  .align-left;
}
.disabled{
    color: #c3c3c3;
}
.text-align-left {
  text-align: left;
}
.data-row-is-link {
  padding-right: 12px;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphMTMwNTQ2YS1jZjhiLThkNGItODM5YS0wMTFjZTY5Nzk5OTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MUQxNjcxM0Q4REYxMTFFNkExRTRCNjZCMEQ2NUJENzciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MUQxNjcxM0M4REYxMTFFNkExRTRCNjZCMEQ2NUJENzciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OWNiMjBkZmMtODc5Zi1jYjQxLWFmYzEtNzJmOTI5YzMwYmFkIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmExMzA1NDZhLWNmOGItOGQ0Yi04MzlhLTAxMWNlNjk3OTk5NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjUEGAYAAAD2SURBVHjapJQxCgIxEEV11F4QK20tvIGtgqVgoRZew9rGC3gIQRurtbJRbLQUBD2EsGCtKP5ABpYQk0kceOzOwn+Q2dnNH47n3D9F+joFJ9CPEVTADLTAGgxDBQ9w0X0BrEIkSvAGXXCLkfAM7qAdI6HMfZSEjD5YQpZnLLkakpFUwJKOIVnaJOQ4nkhCniF7JSR41U4JCRfOJlmAKgWsfUnD9QKfojBcA3vQ0P0TjEFKkWG1WIlkBs6wT+ANuwSi8C+BOGwTBIVNQd0SHrjCWYEK7yzhjeSPpNZyGxNmQRk0Y8IsSMFEH6EXElbF38JcE1xfAQYA221NI+cOj78AAAAASUVORK5CYII=")
    center right no-repeat;
  background-size: 8px 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataRow.vue